interface CircularProgressProps {
  value: number;
  size?: "sm" | "md" | "lg";
  strokeWidth?: number;
  color?: string;
  label?: string;
  /** Texto do centro; padrão `${value}%`. Use para formatar no locale. */
  valueLabel?: string;
}

const sizeClasses = {
  sm: "w-16 h-16",
  md: "w-24 h-24",
  lg: "w-36 h-36",
};

const defaultRadius = {
  sm: 28,
  md: 40,
  lg: 40,
};

export function CircularProgress({
  value,
  size = "lg",
  strokeWidth = 4,
  color = "text-teal-600",
  label,
  valueLabel,
}: CircularProgressProps) {
  const radius = defaultRadius[size];
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (value / 100) * circumference;

  return (
    <div
      className={`relative ${sizeClasses[size]} flex items-center justify-center`}
    >
      <svg className={`${sizeClasses[size]} -rotate-90`} viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          className="text-gray-200"
        />
        <circle
          cx="50"
          cy="50"
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className={`${color} transition-all duration-300`}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-2xl font-medium text-gray-900">
          {valueLabel ?? `${value}%`}
        </span>
        {label && <span className="text-xs text-gray-400">{label}</span>}
      </div>
    </div>
  );
}
